<div class="p-4">
  <div class="flex items-center justify-between mb-4">
    <h2 class="text-lg font-semibold">Pending Deletions</h2>
    <button class="text-xs uppercase tracking-wide border rounded px-3 py-1 hover:bg-gray-100"
            (click)="refresh()" [disabled]="loading">
      {{ loading ? 'Loading…' : 'Refresh' }}
    </button>
  </div>

  <div *ngIf="!loading && rows.length === 0" class="text-sm text-gray-500 py-8 text-center">
    No pending deletions.
  </div>

  <table *ngIf="rows.length > 0" class="w-full text-sm border-collapse">
    <thead>
      <tr class="text-left text-xs uppercase tracking-wide text-gray-500 border-b">
        <th class="py-2 pr-3">User</th>
        <th class="py-2 pr-3">Customers</th>
        <th class="py-2 pr-3">Requested by</th>
        <th class="py-2 pr-3">Reason</th>
        <th class="py-2 pr-3">When</th>
        <th class="py-2 pr-3 w-72">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows" class="border-b">
        <td class="py-2 pr-3">
          <div class="font-medium">{{ row.user?.attributes?.email || row.username }}</div>
          <div class="text-xs text-gray-500">{{ row.username }}</div>
        </td>
        <td class="py-2 pr-3 text-xs">{{ row.user?.attributes?.['custom:customers'] || '—' }}</td>
        <td class="py-2 pr-3 text-xs">
          {{ row.requestedBy }}
          <div class="text-gray-500">{{ row.requestedByRole }}</div>
        </td>
        <td class="py-2 pr-3 text-xs">{{ row.reason || '—' }}</td>
        <td class="py-2 pr-3 text-xs">{{ fmtDate(row.requestedAt) }}</td>
        <td class="py-2 pr-3">
          <div class="flex gap-2 items-center">
            <button class="text-xs px-3 py-1 rounded bg-red-600 text-white hover:bg-red-700"
                    (click)="approve(row)">
              Approve delete
            </button>
            <input type="text" placeholder="reject reason (optional)"
                   [(ngModel)]="rejectReason[row.username]"
                   class="text-xs border rounded px-2 py-1 flex-1 min-w-[140px]" />
            <button class="text-xs px-3 py-1 rounded border hover:bg-gray-100"
                    (click)="reject(row)">
              Reject
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
